<template lang="pug">
button.CustomBtn(@click="click"): slot
</template>

<script>
export default {
  name: 'CustomBtn',
  props: {
    title: { type: String, default: document.title },
    text: { type: String, default: '' },
    url: { type: String, default: window.location.origin },
    via: { type: String, default: 'rezozero' }
  },
  methods: {
    click (e) { this.$emit('click', e) }
  }
}
</script>

<style lang="scss" scoped>
.CustomBtn {
  cursor: pointer;
  height: 57px;
  width: 57px;
  border-radius: 50%;
  border: solid 1px rgba($white, 0.5);
  color: $white;
  background: none;
  transition: .2s ease-out;

  &:hover { scale: 0.95; }

  svg {
    fill: currentColor;
    height: 18px;
  }
}
</style>
